export default __webpack_public_path__ + "static/eclipse-cca932cec76d052df2e76b77546fc595.jpg";